// This is for the production site, which is hosted at https://angular.io/.
export const environment = {
  legacyUniversalAnalyticsId: 'UA-59853299-3', // Production id
  googleAnalyticsId: 'G-ZE76R447BW', // Production id

  production: true,
  mode: 'stable',
};
